import { render, staticRenderFns } from "./MindElixirDialog.vue?vue&type=template&id=21c8f535&scoped=true"
import script from "./MindElixirDialog.vue?vue&type=script&lang=js"
export * from "./MindElixirDialog.vue?vue&type=script&lang=js"
import style0 from "./MindElixirDialog.vue?vue&type=style&index=0&id=21c8f535&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21c8f535",
  null
  
)

export default component.exports